import(/* webpackMode: "eager", webpackExports: ["LoginForm"] */ "/var/www/clients/client1/web9/home/kupcochceszpanel/panel/src/app/(auth)/login/LoginForm.tsx");
